module.exports = __webpack_public_path__ + "static/media/spaceV1.28c2e1a6.png";